import React, { useId } from "react";
import { bandColor } from "../lib/perf";
import { useTween } from "../lib/useTween";

// Premium 180° gauge for HITMAX Index (0-100).
// Coloured value arc sits exactly on the track curve, over a subtle red->mint scale.
export const IndexGauge = ({ value, band, size = 160, label = "Index" }) => {
  const color = bandColor(band);
  const v = useTween(value);
  const f = Math.max(0, Math.min(1, v / 100));
  const gid = "g" + useId().replace(/:/g, "");

  const cx = 50, cy = 50, r = 42, sw = 9;
  const theta = ((180 - f * 180) * Math.PI) / 180;
  const ex = cx + r * Math.cos(theta);
  const ey = cy - r * Math.sin(theta);
  const track = `M ${cx - r} ${cy} A ${r} ${r} 0 0 1 ${cx + r} ${cy}`;
  const val = `M ${cx - r} ${cy} A ${r} ${r} 0 0 1 ${ex} ${ey}`;

  return (
    <div className="relative" style={{ width: size, height: size * 0.62 }} data-testid="index-gauge">
      <svg viewBox="0 0 100 56" className="absolute inset-0 w-full h-full" style={{ overflow: "visible" }}>
        <defs>
          <linearGradient id={gid} x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#E53935" />
            <stop offset="38%" stopColor="#FB8C00" />
            <stop offset="66%" stopColor="#43A047" />
            <stop offset="100%" stopColor="#00E676" />
          </linearGradient>
        </defs>
        {/* base track */}
        <path d={track} fill="none" stroke="rgba(255,255,255,0.07)" strokeWidth={sw} strokeLinecap="round" />
        {/* faint colour scale so the range is visible */}
        <path d={track} fill="none" stroke={`url(#${gid})`} strokeWidth={sw} strokeLinecap="round" opacity="0.22" />
        {/* value arc — colour ON the curve */}
        <path
          d={val}
          fill="none"
          stroke={color}
          strokeWidth={sw}
          strokeLinecap="round"
          style={{ filter: `drop-shadow(0 0 4px ${color})` }}
        />
        {/* marker */}
        <circle cx={ex} cy={ey} r={3.2} fill="#0A0A0A" stroke={color} strokeWidth="2"
          style={{ filter: `drop-shadow(0 0 5px ${color})` }} />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-end pb-0.5 pointer-events-none">
        <span className="font-numeral font-black leading-none" style={{ color, fontSize: size * 0.3 }}>
          {Math.round(v)}
        </span>
        {label ? (
          <span className="text-[9px] font-bold uppercase tracking-[0.22em] text-white/40 mt-0.5">{label}</span>
        ) : null}
      </div>
    </div>
  );
};
